<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-foreword element-with-heading" id="foreword">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-mixed">Foreword</h1>
</div>
</div>
</div>
</div>
<div class="text" id="foreword-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>“We’re all a little broken, aren’t we?</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>Some cause the breakage, some are left with the pieces.</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>But, each of us hold that weight.</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>The amount of weight depends on the person,</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>Depends on the action.</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>Some are hurt, others just hurt.</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>But, each of us hold that weight.</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>We’re all a little broken, aren’t we?”</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?6cedd201